import { Component, input } from '@angular/core';

import { RecruiteeLogoFullComponent } from './recruitee-logo-full/recruitee-logo-full.component';
import { RecruiteeLogoSignetComponent } from './recruitee-logo-signet/recruitee-logo-signet.component';

export enum RecruiteeLogoType {
  Full = 'Full',
  Signet = 'Signet',
}

@Component({
  selector: 'rt-recruitee-logo',
  templateUrl: './recruitee-logo.component.html',
  host: {
    '[class]': 'type()',
  },
  styles: `
    :host {
      display: flex;
    }
  `,
  imports: [RecruiteeLogoSignetComponent, RecruiteeLogoFullComponent],
})
export class RecruiteeLogoComponent {
  public type = input<RecruiteeLogoType>(RecruiteeLogoType.Full);
  public RecruiteeLogoType = RecruiteeLogoType;
}
